module.exports = __webpack_public_path__ + "static/media/guided_path.2ce8a38a.svg";